import { Box, Typography } from '@mui/material';

function DurationEventWarning() {
  return (
    <Box display="flex" flexDirection="column" justifyContent="center" px={1} py={4}>
      <Typography textAlign="center" fontSize={20} fontWeight={500}>
        There are existing duration events that fall outside the updated session duration.
      </Typography>
      <Typography textAlign="center" fontSize={21} fontWeight={500} mt={2} mb={1}>
        Please delete or adjust these events before <br /> proceeding with the update.
      </Typography>
    </Box>
  );
}
export default DurationEventWarning;
